import { fromJS } from 'immutable';
import { actionTypes } from '../../actions/AiStreamingAssistant/aiStreamingAssistantActions';

let defaultState = {
  showSidePanel: false,
  loading: false,
  messages: [],
  streamingStatus: null,
};

export default function aiStreamingAssistantReducer(state = fromJS(defaultState), action) {
  switch (action.type) {
    case actionTypes.AI_STREAMING_ASSISTANT__SHOW_SIDE_PANEL:
      return state.set('showSidePanel', true);

    case actionTypes.AI_STREAMING_ASSISTANT__HIDE_SIDE_PANEL:
      return state.set('showSidePanel', false);

    case actionTypes.AI_STREAMING_ASSISTANT__ADD_MESSAGE:
      return state.update('messages', (messages) => messages.push(fromJS(action.payload)));

    case actionTypes.AI_STREAMING_ASSISTANT__SET_LOADING:
      return state.set('loading', action.payload);

    case actionTypes.AI_STREAMING_ASSISTANT__CLEAR_MESSAGES:
      return state.set('messages', fromJS([])).set('streamingStatus', null);

    case actionTypes.AI_STREAMING_ASSISTANT__LOAD_MESSAGES: {
      const messages = action.payload || [];
      return state.set('messages', fromJS(messages));
    }

    case actionTypes.AI_STREAMING_ASSISTANT__START_STREAMING:
      return state.update('messages', (messages) =>
        messages.push(fromJS({
          id: action.payload.id,
          role: 'assistant',
          text: '',
          timestamp: action.payload.timestamp,
          streaming: true,
        }))
      );

    case actionTypes.AI_STREAMING_ASSISTANT__APPEND_CHUNK: {
      const lastIdx = state.get('messages').size - 1;
      return state
        .updateIn(['messages', lastIdx, 'text'], (text) => (text || '') + action.payload)
        .set('streamingStatus', null);
    }

    case actionTypes.AI_STREAMING_ASSISTANT__FINISH_STREAMING: {
      const lastIdx = state.get('messages').size - 1;
      return state
        .setIn(['messages', lastIdx, 'streaming'], false)
        .set('streamingStatus', null);
    }

    case actionTypes.AI_STREAMING_ASSISTANT__SET_STATUS:
      return state.set('streamingStatus', action.payload);

    default:
      return state;
  }
}
